<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="editableTabsValue" type="card" @tab-remove='removeTab' :before-leave='Tabever'>
    <el-tab-pane :key="item.name" v-for="(item) in editableTabs" :label="item.title" :name="item.name" :closable="item.closable">
      <component :is="item.content" @addTab="addTab()" @removeTab="removeTab(item.name)" :minor='1'></component>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
/**
 * lx
 * 矿业咨询服务管理页面
 */
import {mapState} from 'vuex'
import KyzxfwAdd from '../../../../static/form/KyzxfwAdd.vue'
import KyzxfwLB from '../assembly/KyzxfwLB.vue'
import KyzxFlfwLB from '../assembly/KyzxFlfwLB.vue'
import CjwtLB from '../assembly/CjwtLB.vue'
import ComboBox from '../assembly/ComboBox.vue'
import Classification from '../assembly/Classification.vue'
export default {
  components: {
    KyzxfwAdd,
    KyzxfwLB,
    KyzxFlfwLB,
    CjwtLB,
    ComboBox,
    Classification
  },
  data()
  {
    return {
      editableTabsValue: '1',
      editableTabs: [{
        title: '矿业咨询问卷列表',
        name: '1',
        closable: false,
        ref: 'child',
        content: KyzxfwLB
      },
      {
        title: '法律咨询问卷列表',
        name: '2',
        closable: false,
        ref: 'child',
        content: KyzxFlfwLB
      },
      {
        title: '常见问题列表',
        name: '3',
        closable: false,
        ref: 'child',
        content: CjwtLB
      }],
      addobj: {
        title: '添加服务配置',
        name: '4',
        closable: true,
        content: KyzxfwAdd
      }
    }
  },
  computed:
  {
    ...mapState({
      getActiveName: state => state.activeName
    })
  },
  watch:
  {
    getActiveName:
    {
      handler(nval, oval)
      {
        if (nval.activeName)
          this.editableTabsValue = nval.activeName
        else
          this.editableTabsValue = this.editableTabsValue
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    Tabever(activeName, oldActiveName)
    {
      if (activeName === '1')
        this.$store.commit('onIsLb', '1')
      this.$store.commit('onActiveName', activeName)
    },
    //父组件新增添加Tabs
    addTab()
    {
      let that = this
      window.public.addTab(that)
    },
    //删除添加Tabs
    removeTab(targetName)
    {
      let that = this
      window.public.removeTab(targetName, that)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/Kyzxfwgl.vue